module.exports = __webpack_public_path__ + "png/search-icon.png?4d7c696fc9fbb5ef9f4f9bc2b7a84b4f";